import * as React from 'react';
export var LinearNavigationContext = React.createContext([]);
export var LinearNavigationProvider = LinearNavigationContext.Provider;